import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import url from "../api/url";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";
import { jwtDecode } from "jwt-decode";


export const useLogin = () => {

    const [TrayendoPermisos, setTrayendoPermisos] = useState(false)
    const [mostrarBtnLogin, setMostrarBtnLogin] = useState(true);
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const setObjLogueado = useEmpleadoStore(state => state.setObjLogueado)

    let history = useHistory();

    const { URL } = url()

    const onLoginSuccess = (res) => {

        var payload = jwtDecode(res.credential)

        var {
            email,
            family_name: apellido,
            given_name: nombre,
            exp
        } = payload
        var token = res.credential;


        setMostrarBtnLogin(false)

        setObjLogueado({ email, nombre, apellido, token, exp })

    }

    function traerPermisosTxt() {

        if (TrayendoPermisos && objLogueado.token) return <>Validando correo...</>
    }


    const traerPermisos = () => {

        const epochTime = objLogueado.exp;
        const currentTime = Math.floor(Date.now() / 1000);

        // eslint-disable-next-line
        if (epochTime == undefined ||epochTime < currentTime) {
            localStorage.removeItem('user_empleado')
            return
        }

        setTrayendoPermisos(true)

        var fd = new FormData()
        fd.append("funcion", "validarLogin")
        fd.append("token", objLogueado.token)
        fd.append("email", objLogueado.email)

        fetch(URL, {
            method: 'post',
            body: fd
        })
            .then(res => res.json())
            .then(function (d) {
                var obj2;

                switch (d.codigo) {
                    case 0:
                        setTrayendoPermisos(false)
                        alert("Error al acceder con tu cuenta de Google\nIntenta con otro navegador");
                        break;

                    case 1:
                        // registrado
                        obj2 = objLogueado
                        obj2.permitido = "empleado"
                        obj2.nombre = d.nombre
                        obj2.apellido = d.apellidos
                        setObjLogueado(obj2)

                        localStorage.setItem('user_empleado', JSON.stringify({
                            email: objLogueado.email,
                            nombre: objLogueado.nombre,
                            apellido: objLogueado.apellido,
                            token: objLogueado.token,
                            permitido: "empleado"
                        }))
                        setTrayendoPermisos(false)
                        history.push("/menu");
                        break;

                    case 2:
                        setTrayendoPermisos(false)
                        alert("Hubo un problema al registrarte");
                        break;

                    case 3:
                        obj2 = objLogueado
                        obj2.permitido = "admin"
                        setObjLogueado(obj2)

                        localStorage.setItem('user_empleado', JSON.stringify({
                            email: objLogueado.email,
                            nombre: objLogueado.nombre,
                            apellido: objLogueado.apellido,
                            token: objLogueado.token,
                            permitido: "admin"
                        }))
                        setTrayendoPermisos(false)
                        history.push("/admin");
                        break;

                    default:
                        setTrayendoPermisos(false)
                        alert("Hubo un error al acceder al sistema")
                        break;
                }

            })
            .catch(e => {
                setTrayendoPermisos(false)
                alert("Hubo un error al acceder al sistema");
            })
        // .finally( () => {
        //     setTrayendoPermisos( false )
        // });

    }

    const onLoginFailure = error => {
        alert("Hubo un error al iniciar sesión")
    }


    useEffect(() => {

        if (objLogueado.token) {
            traerPermisos();
        }
        // eslint-disable-next-line
    }, [objLogueado])

    useEffect(() => {

        localStorage.removeItem('user_empleado')

        // eslint-disable-next-line
    }, [])



    return {
        onLoginSuccess,
        onLoginFailure,
        mostrarBtnLogin,
        objLogueado, traerPermisosTxt
    }
}
